import { render, staticRenderFns } from "./TeamInjuries.vue?vue&type=template&id=2fd8cd6e&scoped=true"
import script from "./TeamInjuries.vue?vue&type=script&lang=js"
export * from "./TeamInjuries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd8cd6e",
  null
  
)

export default component.exports